import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { BrainIcon, ZapIcon, RefreshCwIcon } from 'lucide-react';
const solutions = [{
  icon: <BrainIcon className="w-7 h-7 text-accent-gold mb-2 mx-auto" data-id="element-193" />,
  title: 'ENTENDÉS QUÉ PASA',
  desc: 'Dejás de tenerle miedo al miedo. Cuando entendés la neurociencia detrás del pánico, el 50% del problema desaparece solo.'
}, {
  icon: <ZapIcon className="w-7 h-7 text-accent-gold mb-2 mx-auto" data-id="element-194" />,
  title: 'ACTUÁS EN EL MOMENTO',
  desc: 'Protocolos de 30 a 90 segundos para frenar un ataque donde estés — sin que nadie se dé cuenta.'
}, {
  icon: <RefreshCwIcon className="w-7 h-7 text-accent-gold mb-2 mx-auto" data-id="element-195" />,
  title: 'CAMBIÁS EL PATRÓN DE FONDO',
  desc: 'TCC, ACT y biohacking nervioso para que la ansiedad deje de volver una y otra vez.'
}];
export function SolutionSection() {
  const {
    ref,
    isInView
  } = useInView();
  return <section className="py-4 px-4 bg-primary" ref={ref} data-id="element-196">
      <div className="max-w-6xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5
      }} className="text-center mb-3" data-id="element-198">
          <h2 className="text-xl sm:text-2xl font-bold text-slate-900 mb-1" data-id="element-199">
            La solución definitiva
          </h2>
          <p className="text-text-secondary text-sm sm:text-base" data-id="element-200">
            Un sistema completo que ataca la ansiedad desde todas las capas a la
            vez
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-2" data-id="element-201">
          {solutions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-card border border-gray-200 border-t-[3px] border-t-accent-gold shadow-sm rounded-md py-3 px-3 text-center hover:-translate-y-1 hover:shadow-md transition-all duration-300" data-id="element-202">
              {item.icon}
              <h3 className="text-slate-900 font-bold text-sm mb-1" data-id="element-203">
                {item.title}
              </h3>
              <p className="text-text-secondary text-xs leading-snug" data-id="element-204">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}